import type { FC } from "react";

import { FooterList as FooterListUi } from "@jti/ui/eva-components/Footer/components/FooterList/FooterList";

import type { listInputs } from "./FooterList.builder";

export type ListProps = BuilderComponentProps<typeof listInputs>;

export const FooterList: FC<ListProps> = (props) => {
  return <FooterListUi {...props} />;
};
